module.exports = __webpack_public_path__ + "static/img/ctrlcom.cd47499a.svg";